// extracted by mini-css-extract-plugin
export default {"container":"ScrollToTop_container__FzyIs","icon":"ScrollToTop_icon__CiPGm","visible":"ScrollToTop_visible__QA5zk"};